import React, { useContext, useEffect, useState } from "react";
import { IntContainer, Title, StyledSubTitle, StyledP, Button2, Code, StyledGoBack, StyledVideoContainer, StyledVideo } from "./setup.style";
import LeftArrow from "../../img/Left_Arrow.svg";
import installGif from "../../img/track-conversions.webm";
import FixelDataContext from "../../context/FixelDataContext";
import axiosShopWrapper from "../../services/globalService";
import { useHistory } from "react-router-dom";

const TrackConversions = () => {
  const history = useHistory();
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  const [fxl_code, setFxl_code] = useState("");
  const [didTrack, setDidTrack] = useState(false);

  useEffect(() => {
    fullFixelData.code && setFxl_code(fullFixelData.code);
    // setDidTrack(fullFixelData.conversions&&fullFixelData.conversions.enabled);
  }, [fullFixelData]);

  const confirmAddSnippet = async (e) => {
    e.preventDefault();
    try {
      await axiosShopWrapper("put", "/fixelData/trackConversions");
      const newFixelData = { ...fullFixelData };
      newFixelData.didTrackConversions = true;
      console.log("TCL ~ file: TrackConversions.js ~ line 26 ~ confirmAddSnippet ~ fullFixelData.conversions.enabled", fullFixelData.conversions && fullFixelData.conversions.enabled);
      setFullFixelData(newFixelData);
    } catch (error) {
      console.log("TCL ~ file: TrackConversions.js ~ line 26 ~ confirmAddSnippet ~ error", error.message || error);
    }

    history.push("/setup");
  };
  return (
    <IntContainer>
      <StyledGoBack onClick={() => history.goBack()}>
        <img src={LeftArrow} alt="arrow left" /> Go Back
      </StyledGoBack>
      <Title align="left">Track conversions with Fixel</Title>
      <StyledP>Add the Fixel snippet to checkout pages for a complete view on your high value visitors.</StyledP>
      <StyledSubTitle>Copy the snippet</StyledSubTitle>
      {/*   <script id="fxl_conversions" fxl_code="${code}" src="${conversionScript}"></script>*/}
      <Code>
        {`{% if first_time_accessed %}
<script id="fxl_conversions" fxl_code="${fxl_code}" 
src="https://script.fixel.ai/script/conversions/fxl_conversions_v4.js"></script>
<script>window.fxl && fxl('Purchase', {{ subtotal_price | money_without_currency }}) 
</script>
{% endif %}`}
      </Code>
      <StyledSubTitle>Paste the snippet in the settings page</StyledSubTitle>
      <StyledP>
        Navigate to Setting {">"} Checkout {">"} Order processing (or{" "}
        <a href={`https://${fullFixelData.display}.myshopify.com/admin/settings/checkout`} target="_blank" rel="noreferrer">
          {" "}
          click here
        </a>
        ) and paste the snippet in the Additional scripts box{" "}
      </StyledP>
      {/* TODO add fullscreen option with modal */}
      <StyledVideoContainer>
        <StyledVideo controls>
          <source src={installGif} type="video/webm" />
          support
        </StyledVideo>
      </StyledVideoContainer>
      <br />
      <form onSubmit={confirmAddSnippet}>
        <input type="checkbox" id="doneSnippet" name="doneSnippet" value="done" checked={didTrack} onChange={() => setDidTrack(!didTrack)} />
        <label for="doneSnippet"> I’ve added the snippet to the checkout confirmation page</label>
        <Button2 type="submit" disabled={!didTrack}>
          Done
        </Button2>
      </form>
    </IntContainer>
  );
};
export default TrackConversions;
